import { useEffect, useReducer } from 'react';
import { msUntilNextSiteDay, projectToday } from '../utils/siteTime.js';

/**
 * Today on the SITE's calendar ('YYYY-MM-DD'), whatever zone the viewer is in,
 * and kept right across the site's midnight: a timer waits for the site's next
 * day (not the viewer's) and re-renders, so a page left open rolls over with
 * the site. A string, so its identity is stable for as long as the day lasts.
 *
 * '' while the site's zone is unknown — a guessed zone would silently put the
 * page on the wrong day, so callers wait for the real one.
 */
export function useSiteToday(tz: string | undefined): string {
  const [, rerender] = useReducer((n: number) => n + 1, 0);
  useEffect(() => {
    if (!tz) return;
    let handle: ReturnType<typeof setTimeout>;
    // Re-armed on every firing: a timer that wakes a hair early just waits
    // again for the remainder, and one per day keeps the page on the clock.
    const arm = (): void => {
      handle = setTimeout(() => {
        rerender();
        arm();
      }, msUntilNextSiteDay(tz));
    };
    arm();
    return () => clearTimeout(handle);
  }, [tz]);
  return tz ? projectToday(tz) : '';
}
